import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import ProcessManager from '../../../Common/Managers/ProcessManager';

import { GenericErrorScreen, GenericSimpleButton, GenericModal } from 'com-gyf-webcore-userinterfacecomponents';
import MessagePopup from '../../../Packages/SharedComponents/Com.Gyf.WebCore.MessagePopup.jsx';

import Header from './Header';
import Footer from './Footer';
import BusquedaUsuario from './BusquedaUsuario.jsx';
import ListaPerfiles from './ListaPerfiles';
import ContenedorPermisos from './ContenedorPermisos';
import PopUpPerfiles from './PopUpPerfiles';
import PerfilesSeleccionados from './PerfilesSeleccionados';
import PopUpPermisosNoAsignados from './PopUpPermisosNoAsignados';

class PermisosMasivos extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {

        window.onbeforeunload = function (event) {
            if (sessionStorage.getItem('PantallaCambios') == "true") {
                return "¿Quieres salir de este sitio web? Es posible que los cambios no se guarden.";
            }
        }

        this.props.getScreenData(this.props.currentScope);
    }

    componentWillReceiveProps(nextProps) {
        // if (!nextProps.data.messageHidden) {
        //     setTimeout(() => {
        //         this.props.hidePopUp();
        //     }, 7000);
        // }
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    deleteSessionStorage(){
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios');
        }
    }

    savePermisos = () => {

        const { perfilesSeleccionados, permisos } = this.props.data;

        var funcionalidades = [];
        let localValues = {}
        perfilesSeleccionados.forEach(function (perfil) {
            permisos.forEach(function (permiso) {
                if (perfil.ProductoId != null && perfil.ProductoId != permiso.productoId)
                    permiso.funciones.forEach(function (funcion) {
                        localValues = {
                            'PERFIL_CODIGO': perfil.Codigo,
                            'PRODUCTO_ID': permiso.productoId,
                            'CATEGORIA_ID': permiso.categoriaId,
                            'PROGRAMA_ID': permiso.programaId,
                            'FUNCION_ID': funcion.id
                        }
                        funcionalidades.push(localValues);
                    });
            });
        });

        if (funcionalidades.length > 0) {

            this.props.openModal();
            $("#permisosSobrePerfil").modal();
        }
        else
            this.props.savePermisos();

    }

    render() {

        const { data } = this.props;

        if (data.redirect == true)
            return <Redirect to={ProcessManager.GetNextStep("PermisosMasivos", "ROUTE_TO_PERFYPERM")} />

        let spinner = null;

        if (data.isFetching == true) {
            spinner = <div className="loading" />
        }

        if (data.functions.length > 0) {
            if (data.functions.Modificacion == true) {
                return (
                    <div className="container-fluid concierge massive-permits">
                        {spinner}

                        {/*POP UP*/}
                        <MessagePopup isHidden={data.messageHidden}
                            message={data.message}
                            classMessage={data.messageClass} />
                        <Header permisos={data.permisos}
                            perfilesSeleccionados={data.perfilesSeleccionados}
                            usuariosSeleccionados={data.usuariosSeleccionados}
                            deleteSessionStorage={this.deleteSessionStorage}
                            savePermisos={this.savePermisos} />
                        <ListaPerfiles errorMessagePerfilesUsuarios={data.errorMessagePerfilesUsuarios} />
                        <PerfilesSeleccionados perfilesSeleccionados={data.perfilesSeleccionados}
                            showProfiles={data.showProfiles}
                            deletePerfil={this.props.deletePerfil}
                            showMoreProfiles={this.props.showMoreProfiles}
                            showLessProfiles={this.props.showLessProfiles} />
                        <BusquedaUsuario usuarios={data.usuarios}
                            usuariosSeleccionados={data.usuariosSeleccionados}
                            addUsuario={this.props.addUsuario}
                            deleteUsuario={this.props.deleteUsuario} />
                        <ContenedorPermisos permisos={data.permisos}
                            errorMessageFunciones={data.errorMessageFunciones}
                            addPermiso={this.props.addPermiso}
                            deletePermiso={this.props.deletePermiso}
                            selectProducto={this.props.selectProducto}
                            selectCategoria={this.props.selectCategoria}
                            selectPrograma={this.props.selectPrograma}
                            selectTodasFunciones={this.props.selectTodasFunciones}
                            unselectTodasFunciones={this.props.unselectTodasFunciones}
                            checkFuncion={this.props.checkFuncion} />
                        <Footer permisos={data.permisos}
                            perfilesSeleccionados={data.perfilesSeleccionados}
                            usuariosSeleccionados={data.usuariosSeleccionados}
                            savePermisos={this.savePermisos} />

                        {/*MODALES*/}
                        <GenericModal type="ALL_CUSTOM"
                            className="modal fade-out"
                            id="confirm-cancel"
                            screenSize="modal-dialog modal-generic"
                            header={
                                <h2 className="modal-title">Descartar cambios</h2>}
                            footer={
                                <div className="row">
                                    <div className="col-xs-4">
                                        <button className="btn btn-primary btn-cta" onClick={() => this.props.setRedirectOk()}>Descartar Cambios</button>
                                    </div>
                                    <div className="col-xs-8">
                                        <GenericSimpleButton text="Cancelar" dataDismiss="modal" buttonClass="btn btn-default btn-secondary" />
                                    </div>
                                </div>}
                            body={<p>Usted tiene cambios sin guardar. Quiere descartarlos y volver a la pantalla de perfiles y permisos?</p>} />

                        <PopUpPermisosNoAsignados id={"permisosSobrePerfil"}
                            perfilesSeleccionados={data.perfilesSeleccionados}
                            permisos={data.permisos}
                            save={this.props.savePermisos}
                            categorias={data.categorias}
                            productos={data.productos}
                            programas={data.programas}
                        />
                        <PopUpPerfiles id={"listProfileModal"}
                            productos={data.productos}
                            perfiles={data.perfiles}
                            perfilesSeleccionados={data.perfilesSeleccionados}
                            savePerfiles={this.props.savePerfiles}
                        />
                    </div>);
            }
            else {
                let values = {
                    message: "Disculpe, no tiene permisos para acceder a esta pantalla.",
                    linkMessage: "Volver a mi pagina de inicio"
                };

                return (
                    <div>
                        {spinner}
                        <GenericErrorScreen data={values} />
                    </div>);
            }
        }
        else {
            return spinner;
        }
    }
}

export default PermisosMasivos;